import type {
  AdminEventAttendeeListDto,
  AdminEventAttendeeQuery,
  AdminEventStatsListDto,
  AdminEventStatsQuery,
  AdminEventsByCityDto,
  AdminPlatformStatsDto,
} from '@icebreaker/shared';
import { api } from '@/shared/api/client';

/**
 * Genel görünüm panosu `api` katmanı (kullanıcı kararı 2026-09-02 §3) —
 * YALNIZCA sagalardan çağrılır. Dört uç da sunucuda `admin:moderate`
 * kapısının arkasındadır.
 */

export async function fetchPlatformStats(): Promise<AdminPlatformStatsDto> {
  return await api.admin.statsOverview();
}

export async function fetchEventsByCity(): Promise<AdminEventsByCityDto> {
  return await api.admin.statsEventsByCity();
}

export async function fetchEventStats(
  query: AdminEventStatsQuery,
): Promise<AdminEventStatsListDto> {
  return await api.admin.statsEvents({
    status: query.status,
    cityCode: query.cityCode,
    page: query.page,
    pageSize: query.pageSize,
  });
}

/** Katılımcı dökümü — sunucuda denetim kaydı düşürür, yalnız istendiğinde çağrılır. */
export async function fetchEventAttendees(
  eventId: string,
  query: AdminEventAttendeeQuery,
): Promise<AdminEventAttendeeListDto> {
  return await api.admin.statsEventAttendees(eventId, {
    page: query.page,
    pageSize: query.pageSize,
  });
}
